import { createPinia } from 'pinia'
import { createApp } from "vue";
import App from "./App.vue";
import { Sentry } from "@/helpers/sentry";
import router from "./router";
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import i18n from '@/i18n/main'
// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { dedupeIntegration } from '@sentry/vue';

const vuetify = createVuetify({
    components,
    directives,
})

window.$ = window.jQuery = require('jquery');

const app = createApp(App);
app.use(Sentry).use(router).use(createPinia().use(piniaPluginPersistedstate)).use(i18n).use(vuetify);

app.config.errorHandler = (err, vm, info) => {
    // Redirect to the error page
    router.replace({ name: 'internal.server.error' });
};

app.mount("#app");
